import { useState, useEffect } from 'react';
import { FaSearch } from 'react-icons/fa';
import { MdExpandMore } from 'react-icons/md';
import BotaoPadrao from '../BotaoPadrao/BotaoPadrao';
import './FiltroPadrao.css';

const FiltroPadrao = ({ 
  children, 
  expandedChildren,
  filtrar, 
  limparFiltros, 
  expansivo = false
}) => {
  const [expandido, setExpandido] = useState(false);
  const [textVisible, setTextVisible] = useState(true);
  const [showText, setShowText] = useState('Mais Filtros');

  const toggleExpand = () => {
    setTextVisible(false);
    setTimeout(() => {
      setExpandido(prev => {
        const novo = !prev;
        setShowText(novo ? 'Mostrar menos' : 'Mais Filtros');
        setTextVisible(true);
        return novo;
      });
    }, 150);
  };

  useEffect(() => {
    setShowText(expandido ? 'Mostrar menos' : 'Mais Filtros');
  }, [expandido]);

  return (
    <div className="filtro-padrao-container">
      <div className="filtro-padrao-content"> 
        {children}
      </div>
      {expansivo && (
        <div className={`filtro-padrao-content filtro-padrao-content-expansivo${expandido ? ' aberto' : ' fechado'}`}>
          {expandedChildren}
        </div>
      )}
      <hr className="filtro-padrao-divider" />

      <div className="filtro-padrao-actions-row">
        <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
          {expansivo && (
            <div className="filtro-padrao-expansivo-wrapper" onClick={toggleExpand}>
              <div className={`seta-expansao ${expandido ? 'expandido' : ''}`}>
                <MdExpandMore />
              </div>
              <span className={`texto-expansao ${textVisible ? 'visible' : 'hidden'}`}>{showText}</span>
            </div>
          )}
        </div>
        <div className="filtro-padrao-actions-btns">
          <BotaoPadrao 
            aoClicar={limparFiltros} 
            texto="Limpar Filtros" 
            cancelar={true} 
          />
          <BotaoPadrao
            aoClicar={filtrar}
            texto="Pesquisar"
            confirmar={true}
            icone={<FaSearch size={16}/>} 
          />
        </div>
      </div>
    </div>
  );
};

export default FiltroPadrao;